export default {
  CancelarDebitoAutomatico: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "cancelar-pedido-debito-automatico"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/CancelarDebitoAutomatico.js
// module id = iLeX
// module chunks = 13